import React from 'react';
import { motion } from 'framer-motion';
import { pageTransition, pageVariants } from '../constants/pageMotion';

export default function AcercaDe() {
  return (
    <motion.section
      variants={pageVariants}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={pageTransition}
      className="max-w-5xl mx-auto px-4 py-12 md:px-6"
    >
      <div className="bg-white border border-slate-100 rounded-3xl shadow-sm p-10 md:p-12">
        <span className="bg-slate-100 text-slate-600 text-[10px] font-bold px-3 py-1 rounded-full uppercase tracking-widest">Proyecto editorial</span>
        <h2 className="mt-5 text-3xl font-extrabold leading-tight sm:text-4xl md:text-5xl">Acerca de</h2>
        <div className="flex gap-1.5 my-5">
          <span className="w-8 h-[2px] bg-amber-200 rounded-full" />
          <span className="w-8 h-[2px] bg-blue-200 rounded-full" />
          <span className="w-8 h-[2px] bg-red-200 rounded-full" />
        </div>
        
        <div className="my-8 p-6 rounded-2xl bg-gradient-to-r from-amber-50/40 via-blue-50/40 to-red-50/40 border border-slate-100/80 relative overflow-hidden shadow-xs">
          <div className="absolute left-0 top-0 bottom-0 w-[4px] bg-gradient-to-b from-amber-300 via-blue-300 to-red-300" />
          <p className="text-lg md:text-xl font-bold text-slate-800 leading-relaxed pl-4">
            Construyendo democracia a través del voto informado en Colombia.
          </p>
        </div>

        <p className="mt-6 text-slate-600 text-lg leading-8">
          Este proyecto nace con una idea simple: ayudar a las personas a votar con más contexto, menos ruido y mejor criterio. La experiencia está pensada para resumir de forma visual las diferencias entre propuestas, trayectorias y prioridades de los candidatos.
        </p>
        <p className="mt-4 text-slate-600 text-lg leading-8">
          También utilizamos IA para organizar y sintetizar información pública en bloques comparables, de manera que el usuario pueda navegar por temas, candidatos y datos relevantes sin perderse en textos largos o dispersos.
        </p>

        <div className="grid md:grid-cols-2 gap-6 mt-10">
          <div className="rounded-3xl bg-slate-50 p-6 border border-slate-100">
            <h3 className="text-lg font-bold mb-3">Voto Informado</h3>
            <p className="text-slate-600 leading-7">Buscamos dar una vista clara y neutral de las propuestas para facilitar una decisión más consciente, comparando contenido, trayectorias y prioridades de campaña.</p>
          </div>
          <div className="rounded-3xl bg-slate-50 p-6 border border-slate-100">
            <h3 className="text-lg font-bold mb-3">Disclaimer</h3>
            <p className="text-slate-600 leading-7">Este sitio no reemplaza la lectura directa de programas oficiales ni el seguimiento periodístico especializado. La información resumida puede requerir verificación adicional antes de tomar decisiones electorales.</p>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
